import { CLICK, MISSED_CLICK, SCROLL } from '../constants/actionTypes';
export function missedClick(position, scrollPos) {
    return {
        type: MISSED_CLICK,
        position: position,
        meta: {
            screenScrollPos: scrollPos,
        },
    };
}
export function click(position) {
    return {
        type: CLICK,
        // TODO add metadata for different types of click (change screen, show
        // overlay etc.) ?
        position: position,
    };
}
export function scroll(targetType, scrollLeft, scrollTop, screenID) {
    return {
        type: SCROLL,
        screenID: Number(screenID),
        targetType: targetType,
        // scroll offset should be provided at the current scale of the layer
        scrollLeft: scrollLeft,
        scrollTop: scrollTop,
    };
}
